function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import TextAtm from "../../../../atoms/TextAtm";
import FlexContainerOrg from "../../../../organisms/FlexContainerOrg";
import { pricesTypographies } from "../../priceMol.config";
var AdditionalInformationElement = function AdditionalInformationElement(_ref) {
  var additionalInformation = _ref.additionalInformation,
    variant = _ref.variant;
  var typographies = pricesTypographies[variant.type];
  var textPosition;
  switch (variant.align) {
    case "right":
      textPosition = "flex-end";
      break;
    case "center":
      textPosition = "center";
      break;
    default:
      textPosition = "flex-start";
  }
  return /*#__PURE__*/React.createElement(FlexContainerOrg, {
    gapSpace: {
      rowGap: 0.5,
      columnGap: 1
    },
    wrap: "wrap",
    alignItems: "center",
    justifyContent: textPosition
  }, additionalInformation.map(function (infoLine, index) {
    return /*#__PURE__*/React.createElement(TextAtm
    // eslint-disable-next-line react/no-array-index-key
    , _extends({
      key: "price-additional-info-".concat(index)
    }, typographies.infoText, {
      htmlTag: "div"
    }), infoLine);
  }));
};
export default AdditionalInformationElement;